import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {routes} from './app.routes';
import {providePrimeNG} from 'primeng/config';
import MyPreset from '../preset';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {MessageService} from 'primeng/api';
import {DialogService} from "primeng/dynamicdialog";
import {OAuthModule, OAuthService, provideOAuthClient} from "angular-oauth2-oidc";
import {AuthInterceptor} from "./core/interceptors/auth.interceptor";
import {environment} from "../environments/environment";
import { activeLocationInterceptor } from './core/interceptors/active-location.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptorsFromDi(),                 
      withInterceptors([activeLocationInterceptor])
    ),
    provideOAuthClient(),
    importProvidersFrom(
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.allowedUrl],
          sendAccessToken: true
        }
      }),
      OAuthService
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    DialogService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
          },
          darkModeSelector: 'none'
        }
      }
    }),
    MessageService
  ]
};
